import { Stack } from '@jarvis/web-stratus-client';

export const ONBOARDING_CENTER_STACK_HOSTNAMES = {
  [Stack.dev]: 'https://onboardingcenter.dev.portalshell.int.hp.com',
  [Stack.pie]: 'https://onboardingcenter.pie.portalshell.int.hp.com',
  [Stack.stage]: 'https://onboardingcenter.stage.portalshell.int.hp.com',
  [Stack.prod]: 'https://start.hp.com',
};

export const APP_URLS = {
  WINDOWS_APP_URL: 'ms-windows-store://pdp?ProductId=9wzdncrfhwlh',
  MAC_APP_URL: 'macappstore://apps.apple.com/us/app/hp-smart/id1474276998?mt=12',
  IOS_APP_URL: 'https://apps.apple.com/app/hp-smart/id469284907',
  ANDROID_APP_URL: 'https://play.google.com/store/apps/details?id=com.hp.printercontrol',
};

export const DEEPLINKS = {
  INSTANT_INK: 'instantink',
  INSTANT_INK_OVERVIEW: 'instantink/overview',
};

export const GET_SOFTWARE_URL = 'https://start.hp.com/get-software';

export const USER_ROLES = {
  ADMIN: 'admin',
  END_USER: 'endUser',
};
